const t = (e) => ({
  scrollPaper: {
    alignItems: "flex-end"
  },
  mainWrapper: {
    padding: 0,
    "&:first-of-type": {
      paddingTop: 0
    }
  },
  header: {
    backgroundColor: e.palette.common.white,
    boxShadow: "none",
    borderBottom: `1px solid ${e.palette.common.grey20}`
  },
  headerContent: {
    padding: 20,
    display: "flex",
    "@media(min-width: 768px)": {
      flexDirection: "row-reverse"
    }
  },
  closeIcon: {
    padding: 0,
    "@media(max-width: 768px)": {
      "& svg.MuiSvgIcon-root": {
        width: 20
      }
    }
  },
  titleWrapper: {
    flex: "1 1 auto",
    textAlign: "center"
  },
  headerTitle: {
    color: e.palette.text.primary,
    fontSize: e.typography.fontSize15,
    lineHeight: 1.4,
    fontWeight: e.typography.fontWeightSemiBold
  }
}), o = t;
export {
  o as default
};
